/* eslint-disable vue/valid-template-root */
<template>
	<div>
		<main class="main hidden">
			<header class="navbar navbar-expand-lg navbar-dark">
				<div class="container position-relative">
					<router-link to="/" class="navbar-brand">
						<img
							class="navbar-brand__regular"
							src="/assets/logo.png"
							alt="brand-logo"
							width="80px"
							height="80px"
						/>
					</router-link>
				</div>
			</header>

			<section
				class="space theme-blue bg-color--dark--1 h-min-100vh d-flex align-items-center"
			>
				<div class="svg-shape--top w-100 opacity--05">
					<img
						src="/assets/img/wave-8.svg"
						alt="wave"
						class="svg fill--white"
					/>
				</div>

				<div class="svg-shape--top opacity--10">
					<img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
				</div>

				<div class="container">
				
					<div class="row">
						<div class="col-12 mx-auto color--white text-center mb-2 mb-lg-2">
							<h1 class="h2-font mb-1 text-white">
								{{ $t("supplier.loginSupplier") }}
							</h1>
						</div>
						<div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 mx-auto">
							<div
								class="form--v5 bg-color--light--1 px-3 py-4 px-md-5 pt-md-6 rounded--10"
							>
								<form @submit.stop.prevent="onSubmit">
									<div class="form-group mb-0">
										<label class="form__label font-size--15 font-w--400">{{
											$t("login.melliCode")
										}}</label>
										<input
											id="phone-number"
											type="number"
											@wheel="$event.target.blur()"
											v-model="$v.form.melli_code.$model"
											class="form-control mb-1"
											placeholder="لطفا کدملی خود را وارد کنید"
											required
										/>
										<div class="text-danger" 
										 v-show="!$v.form.melli_code.required && $v.form.$dirty && submitClicked">{{$t("validation.required")}}</div> 
										<!-- <div class="text-danger mr-1" v-show="!$v.form.melli_code.checkMelliCode && 
										$v.form.$dirty && $v.form.melli_code.required && submitClicked">
											{{ $t("validation.MelliCodeCheck") }}
										</div> -->
										
									
									</div>
									<div class="form-group mb-0 mt-2">
										<div class="d-flex justify-content-between">
											<label
												for="password"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("login.password") }}</label
											>
											<!-- <small>
												<router-link
													to="/forgot-pass"
													class="text-color--400"
													>{{ $t("login.forgotPassword") }}</router-link
												>
											</small> -->
										</div>
										<input
											id="password"
											v-model="$v.form.password.$model"
											type="password"
											class="form-control mb-1"
											placeholder="رمز عبور خود را وارد کنید"
											required
										/>

									</div>
									<div class="text-danger p-0 " v-show="!$v.form.password.required && submitClicked">
											{{ $t("validation.required") }}
										</div>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div>
											
										</div>
										<button
											class="btn btn-bg--primary btn-size--md btn-hover--3d"
											@click.prevent="onSubmit()"
										>
											<span class="btn__text">{{ $t("login.login") }}</span>
										</button>
									</div>
								</form>
								<!-- end of form -->
								<div class="text-center mt-4 pt-2 border--top">
									<p class="text-color--400">
										{{ $t("login.newSupplier") }}
										<router-link
											to="/supplier-register"
											href="signup.html"
											class="color--primary"
											>{{ $t("login.signUp") }}</router-link
										>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
	export default {
		data() {
			
			return {
				submitClicked:false,
				form:{

				
				password: "",
				melli_code: ""
				}
			};
		},
		validations:
		{
			form:{
				melli_code:{
					required,
				// 	checkMelliCode(code) {
				// 	if (
				// 		!/^\d{10}$/.test(code) ||
				// 		code == "0000000000" ||
				// 		code == "1111111111" ||
				// 		code == "2222222222" ||
				// 		code == "3333333333" ||
				// 		code == "4444444444" ||
				// 		code == "5555555555" ||
				// 		code == "6666666666" ||
				// 		code == "7777777777" ||
				// 		code == "8888888888" ||
				// 		code == "9999999999"
				// 	)
				// 		return false;
				// 	var check = parseInt(code[9]);
				// 	var sum = 0;
				// 	var i;
				// 	for (i = 0; i < 9; ++i) {
				// 		sum += parseInt(code[i]) * (10 - i);
				// 	}
				// 	sum %= 11;
				// 	return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
				// },
					
				},
				password:{
					required
				}
			}
		},
		mounted() {
			this.$store.dispatch("logout");
			this.$store.dispatch("supplierLogOut");
		},
		methods: {
			onSubmit() {
			this.submitClicked = true
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("login", this.form)
					.then((response) => {
						console.log(response);
						load.hide();
						//this.$router.push("/supplier");
						this.$router.push({name:'SupplierItems'})
						//this.$router.push({ name: "registerPage" });
						//this.$router.push({ path: "/customer/IdentityInfo" });
					})
					.catch((err) => {
						console.log(err);
						if(err.body.detail)
						{
							this.$noty.error(err.body.detail);
						}
						else if(navigator.onLine==false)
						{
							this.$noty.error("شما به اینترنت متصل نیستید");
						}
						
						load.hide();
					});
			}
		},
			login: function () {
				//localStorage.setItem("phone_number", this.mobile_number);
				const loginData = {
					password: this.password,
					mobile_number: this.mobile_number,
				};
				this.$store
					.dispatch("loginSupplier", loginData)
					.then((resp) => {
						this.$router.push("/supplier");
						
						console.log(resp);
					})
					.then((err) => console.log(err));
			},
		},
	};
</script>
